import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuthenticated } from '@jotta/auth-client/useAuthStatus'
import Spinner from '@jotta/ui/Spinner'

import { EntryLayout } from '../components/Layout/EntryLayout'

export function SignupContainer({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) {
  const navigate = useNavigate()
  const authenticated = useAuthenticated()

  useEffect(() => {
    if (authenticated === 'TRUE') {
      navigate('/web/billing')
    }
  }, [navigate, authenticated])
  return (
    <EntryLayout>
      <h2 className="body-lg-ln self-center pb-12">{title}</h2>

      {authenticated === 'FALSE' ? (
        children
      ) : (
        <Spinner className="self-center" />
      )}
    </EntryLayout>
  )
}
